import { render, staticRenderFns } from "./GlobalVariables.vue?vue&type=template&id=0f1529da"
import script from "./GlobalVariables.vue?vue&type=script&lang=js"
export * from "./GlobalVariables.vue?vue&type=script&lang=js"
import style0 from "./GlobalVariables.vue?vue&type=style&index=0&id=0f1529da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports